import { isPractitioner } from 'utils/UserHelper';
import JobHospitalEditModalForPractitionerUser from './JobHospitalEditModalForPractitionerUser';
import JobHospitalEditModalForAdminUser from './JobHospitalEditModalForAdminUser';

const JobHospitalEditModal = ({ modal, setModal }) => {
    if (isPractitioner())
        return <JobHospitalEditModalForPractitionerUser modal={modal} setModal={setModal} />
    else
        return <JobHospitalEditModalForAdminUser modal={modal} setModal={setModal} />
}

export default JobHospitalEditModal;